import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';

interface StyledBooleanCheckboxProps<FieldsType extends FieldValues> {
  control: Control<FieldsType>;
  name: Path<FieldsType>;
  optionLabel: string;
  className?: React.HTMLAttributes<HTMLDivElement>['className'];
  disabled?: boolean;
}

const StyledBooleanCheckbox = <FieldsType extends FieldValues>({
  control,
  name,
  className,
  optionLabel,
  disabled = false,
}: StyledBooleanCheckboxProps<FieldsType>) => {
  return (
    <div className={className}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => {
          return (
            <div className="flex items-center gap-1">
              <Checkbox
                {...field}
                checked={field.value}
                onCheckedChange={() => field.onChange(!field.value)}
                disabled={disabled}
              />
              <Label>{optionLabel}</Label>
            </div>
          );
        }}
      />
    </div>
  );
};

export default StyledBooleanCheckbox;
